import { Component, OnChanges } from '@angular/core';
import { BaseComponent } from '../../shared/base-components/base.component';
import { CustomerIdentification } from '../models/customer-identification.model';
import { CustomerIdentificationType } from '../models/enums/customer-identification-type.enum';
import { CustomerManageService } from '../shared/customer-manage.service';

@Component({
    selector: 'historical-customer-identification',
    templateUrl: './historical-customer-identification.html',
    inputs: ['customerNumber', 'identifications']
})
export class HistoricalCustomerIdentificationComponent extends BaseComponent implements OnChanges {
    public identifications: CustomerIdentification[];
    public customerNumber: number;
    public isRestrictedCustomer = false;
    public isUserLecu = false;

    private identificationTypes = new CustomerIdentificationType();
    private OUT_OF_STATE_DL = 3;
    private PASSPORT = 4;
    private SSN = 5;
    private EIN = 6;
    private INS_NUMBER = 11;
    private MILITARY_ID = 12;
    private OUT_OF_STATE_ID = 100;
    private OIN = 101;

    constructor(private customerService: CustomerManageService) {
        super();
    }

    ngOnInit() {
        if (this.identifications !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateIdentifications(this.customerNumber);
            this.isUserLecu = this.getIsUserLecu();
            if (!this.isUserLecu) {
                // Get is customer restricted based on this will redact the data
                this.getIsCustomerRestricted(this.customerNumber);
            }
        }
    }

    ngOnChanges() {
        if (this.identifications !== undefined) {
            this.denormalizeData();
        } else if (this.customerNumber != null) {
            this.populateIdentifications(this.customerNumber);
        }
    }

    populateIdentifications(customerNumberId: number) {
        this.customerService.getHistoricalCustomerIdentifications(customerNumberId)
            .subscribe(result => {
                this.identifications = result;
            },
            e => console.log('error', e),
            () => {
                this.denormalizeData();
            });
    }

    denormalizeData() {
        for (const identification of this.identifications) {
            identification.identificationType = this.getValues(identification.customerIdentificationTypeId, this.identificationTypes);
            identification.allowEdit = identification.customerIdentificationTypeId == this.OUT_OF_STATE_DL ||
                identification.customerIdentificationTypeId == this.PASSPORT ||
                identification.customerIdentificationTypeId == this.SSN ||
                identification.customerIdentificationTypeId == this.EIN ||
                identification.customerIdentificationTypeId == this.INS_NUMBER ||
                identification.customerIdentificationTypeId == this.MILITARY_ID ||
                identification.customerIdentificationTypeId == this.OUT_OF_STATE_ID ||
                identification.customerIdentificationTypeId == this.OIN;
        }
    }

    getValues(id: number, types: any): string {
        if (id !== undefined && id !== null) {
            return types.FromId(id).displayValue;
        } else {
            return '';
        }
    }

    /**
     * Checks to see whether the user is acccessing the system as part of the LECU business unit.
     * @returns a boolean indicating whether the user is accessing the system as part of the LECU business unit.
     * */
    private getIsUserLecu(): boolean {
        const businessUnit = localStorage.getItem('mvd:bu');

        return businessUnit.indexOf('LECU') > 0;
    }

    /**
     * Fetching customer restricted details to redact the fields based on flag
     * @param customerNumber
     */
    private getIsCustomerRestricted(customerNumber: number) {
        if (customerNumber && customerNumber != null) {
            this.customerService.isCustomerRestricted(customerNumber).subscribe(
                r => this.isRestrictedCustomer = r.result,
                e => this.handleValidationResult(e)
            );
        }
    }
}
